import * as React from 'react';
import Box from '@mui/material/Box';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import EditIcon from '@mui/icons-material/EditTwoTone';
import FilterListIcon from '@mui/icons-material/FilterList';
import GridOffIcon from '@mui/icons-material/GridOff';
import ListIcon from '@mui/icons-material/List';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PrintIcon from '@mui/icons-material/Print';
import Popover from '@mui/material/Popover';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';



export default function FilterSpeedDialNew({ OpenChangeList, SetChangeList, OnFilter, HandleExportClick, SetEmployeeNew }) {
    const [open, setOpen] = React.useState(false);
    const [filterPopoverOpen, setFilterPopoverOpen] = React.useState(false); // State for popover visibility
    const [filterIconPosition, setFilterIconPosition] = React.useState(null);
    const [activeChecked, setActiveChecked] = React.useState(true);
    const [passiveChecked, setPassiveChecked] = React.useState(true);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const handleFilterPopoverOpen = () => setFilterPopoverOpen(true);
    const handleFilterPopoverClose = () => setFilterPopoverOpen(false);


    const handleFilterIconPosition = (event) => {
        setFilterIconPosition(event.currentTarget);
        handleFilterPopoverOpen();
    };

    const actions = [
        { icon: <FilterAltIcon />, name: 'Filtrele', onClick: handleFilterPopoverOpen },
        OpenChangeList ? { icon: <GridOffIcon />, name: 'Görünümü Değiştir', onClick: () => SetChangeList() }
            : { icon: <ListIcon />, name: 'Görünümü Değiştir', onClick: () => SetChangeList() },
        { icon: <PrintIcon />, name: 'Yazdir', onClick: () => HandleExportClick() },
        { icon: <PersonAddIcon />, name: 'Yeni Personel Ekle', onClick: () => SetEmployeeNew() },
    ];

    const handleActiveChecked = (event) => {
        setActiveChecked(event.target.checked);
        handleFilter(event.target.checked, passiveChecked);
    };
    const handleInactiveChecked = (event) => {
        setPassiveChecked(event.target.checked);
        handleFilter(activeChecked, event.target.checked);
    };

    const handleFilter = (active, passive) => {
        var filterData = {
            active: active,
            inactive: passive
        };
        OnFilter(filterData);
    };


    return (
        <Box sx={{ height: 320, transform: 'translateZ(0px)', flexGrow: 1 }}>
            <SpeedDial
                ariaLabel="SpeedDial controlled open example"
                sx={{ position: 'absolute', bottom: 16, right: 16 }}
                icon={<FilterListIcon />}
                openIcon={<EditIcon />}
                onClose={handleClose}
                onOpen={handleOpen}
                open={open || filterPopoverOpen}
                FabProps={{
                    sx: {
                        color: '#FF9800',
                        backgroundColor: '#424242',
                        '&:hover': {
                            backgroundColor: '#FF9800',
                            color: '#424242',
                        }
                    }
                }}
            >
                {actions.map((action) => (
                    <SpeedDialAction
                        key={action.name}
                        icon={action.icon}
                        tooltipTitle={action.name}
                        onClick={action.name === 'Filtrele' ? handleFilterIconPosition : action.onClick}
                        FabProps={{
                            sx: {
                                '&:hover': {
                                    backgroundColor: '#FF9800',
                                }
                            }
                        }}
                    />
                ))}
            </SpeedDial>
            <Popover
                open={filterPopoverOpen}
                anchorEl={filterIconPosition}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'left',
                }}

                onClose={handleFilterPopoverClose}
            >
                <Box sx={{ p: 2 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                        Personel Durumu
                    </Typography>
                    <FormControlLabel
                        control={<Checkbox
                            checked={activeChecked}
                            sx={{ '&.Mui-checked': { color: '#FF9800' } }}
                            onClick={handleActiveChecked} />
                        }
                        label="Aktif" />
                    <FormControlLabel
                        control={<Checkbox
                            checked={passiveChecked}
                            sx={{ '&.Mui-checked': { color: '#FF9800' } }}
                            onClick={handleInactiveChecked}
                        />}
                        label="Pasif" />
                </Box>
            </Popover>
        </Box>
    );
}